import { axiosInstance } from "./axiosInstance";

export const adminService = {
    getAllAdmin: async (filter) => {
        return await axiosInstance.get('/api/superadmin/admin', { params: filter })
    },
    createAdmin: async (data) => {
        return await axiosInstance.post('/api/superadmin/admin/create', data)
    },
    updateAdmin: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/admin/update/${id}`, data)
    },
    deleteAdmin: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/admin/delete/${id}`)
    }
}